import { createModuleInit } from '@rcm/redux-global';
import initPersistShipping from './sagas/initPersistShipping';
import * as discount from './slices/discount';
import * as shipping from './slices/shipping';
import * as showMore from './slices/showMore';
import * as skusSelected from './slices/skusSelected';
import * as view from './slices/view';
import initCart from '@reliv/redux-global-cart';

const initTransferCalculator = createModuleInit({
    deps: [initCart],
    onInitSaga: initPersistShipping,
    reducers: {
        [discount.name]: discount.default,
        [shipping.name]: shipping.default,
        [showMore.name]: showMore.default,
        [skusSelected.name]: skusSelected.default,
        [view.name]: view.default,
    },
});

export default initTransferCalculator;
